import { SingleValueToolbarSlotProps } from '../types/single-value-toolbar.js';

export const Toolbar = (props: SingleValueToolbarSlotProps) => null;

Toolbar['displayName'] = 'SingleValue.Toolbar';
